import { find } from 'lodash';

export const createStreetAddress = (result: any) => {
  const route = find(result?.address_components, {
    types: ['route'],
  });

  const streetNumber = find(result?.address_components, {
    types: ['street_number'],
  });

  if (!route?.long_name) {
    return result?.formatted_address || '';
  }

  return [route.long_name, streetNumber?.long_name].filter(Boolean).join(' ');
};

export const formValuesSetter = (
  results: any[],
  setFieldValue: any,
  isGoogleMapAddressValidSetter?: (newBoolValue: boolean) => void,
) => {
  const postalCode = find(results[0].address_components, { types: ['postal_code'] });
  if (!postalCode) {
    isGoogleMapAddressValidSetter && isGoogleMapAddressValidSetter(false);
  } else {
    isGoogleMapAddressValidSetter && isGoogleMapAddressValidSetter(true);
  }

  const isoCountry = find(results[0].address_components, {
    types: ['country', 'political'],
  });
  const cityName = find(results[0].address_components, {
    types: ['locality', 'political'],
  });

  const zupanija = find(results[0].address_components, {
    types: ['administrative_area_level_1', 'political'],
  });

  const opcina =
    find(results[0].address_components, {
      types: ['administrative_area_level_2', 'political'],
    }) ??
    find(results[0].address_components, {
      types: ['administrative_area_level_3', 'political'],
    });

  setFieldValue('zipCode', postalCode?.short_name || '');
  setFieldValue('countryIso2Code', isoCountry?.short_name || '');
  setFieldValue('cityName', cityName?.short_name || '');
  setFieldValue('locationId', null);

  setFieldValue('zupanija', zupanija?.short_name || '');
  setFieldValue('opcina', opcina?.long_name || '');
  setFieldValue('drzava', isoCountry?.long_name || '');

  setFieldValue('address', createStreetAddress(results[0]));
};
